import Base from './Base'

class CopyrightService extends Base {
  find(postData) {
    return this.post('review/query_track_copyright_review', postData, { noEmpty: true })
  }

  findById(postData) {
    return this.post('review/query_track_copyright_review_by_id', postData)
  }

  audit(postData) {
    return this.post('review/review_track_copyrigt_modify', postData)
  }
}

export default new CopyrightService()
